module.exports = __webpack_public_path__ + "images/refreshd66fec805dd437e7d7bbe2bc189e9499.png";